import React from 'react';

import { Tooltip, Flex } from 'antd';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { TruckIcon, AirplaneIcon } from '@icons/index';
import { Currency, enumSign as currencySign } from '@enums/currency';

dayjs.extend(utc);

interface ITariffCard {
    cargoCarrierId?: string;
    flightPrice?: number;
    flightPriceRequired?: boolean;
    truckPrice?: number;
    truckPriceRequired?: boolean;
    currency?: Currency;
    useSecondTruckPrice?: boolean;
    secondTruckPrice?: number | null;
    secondCurrency?: Currency;
}

const TariffCard = (props: ITariffCard) => {
    const {
        cargoCarrierId,
        flightPrice,
        flightPriceRequired,
        truckPrice,
        truckPriceRequired,
        currency,
        useSecondTruckPrice,
        secondTruckPrice,
        secondCurrency,
    } = props;

    return (
        <div>
            {(flightPrice || flightPriceRequired) && (
                <Flex align='center' gap='middle' className='flight-price' style={{ backgroundColor: flightPrice ? '' : '#f29faf' }}>
                    <div>
                        <Tooltip
                            title={flightPrice ? 'Перелет' : 'Укажите тариф за перелет'}
                            placement='topRight'
                            color={flightPrice ? '' : 'var(--main-red)'}
                        >
                            <div>
                                <AirplaneIcon style={{ fontSize: 12 }} />
                            </div>
                        </Tooltip>
                    </div>
                    <div>{flightPrice}</div>
                </Flex>
            )}

            {(truckPrice || truckPriceRequired) && (
                <Flex vertical>
                    <Flex
                        align='center'
                        gap='middle'
                        className={cargoCarrierId ? 'flight-truck-price' : 'truck-price'}
                        style={{ backgroundColor: truckPrice ? '' : '#f29faf' }}
                    >
                        <div>
                            <Tooltip
                                title={
                                    truckPrice
                                        ? cargoCarrierId
                                            ? `Транспортная доставка с перелетом ${currencySign(currency)}`
                                            : `Транспортная доставка ${currencySign(currency)}`
                                        : `Укажите тариф за транспорт ${currencySign(currency)}`
                                }
                                placement='topRight'
                                color={truckPrice ? '' : 'var(--main-red)'}
                            >
                                <div>
                                    <TruckIcon style={{ fontSize: 12, color: cargoCarrierId ? 'var(--cargo-color)' : '' }} />
                                </div>
                            </Tooltip>
                        </div>
                        <Flex>
                            <div>{truckPrice}</div>
                            <div style={{ marginLeft: 2 }}>{currencySign(currency)}</div>
                        </Flex>
                    </Flex>
                    {useSecondTruckPrice && (
                        <Flex
                            align='center'
                            gap='middle'
                            className='truck-price'
                            style={{ backgroundColor: secondTruckPrice ? '' : '#f29faf' }}
                        >
                            <div>
                                <Tooltip
                                    title={
                                        secondTruckPrice
                                            ? `Транспортная доставка ${currencySign(secondCurrency)}`
                                            : `Укажите тариф за транспорт ${currencySign(secondCurrency)}`
                                    }
                                    placement='topRight'
                                    color={secondTruckPrice ? '' : 'var(--main-red)'}
                                >
                                    <div>
                                        <TruckIcon style={{ fontSize: 12, color: cargoCarrierId ? 'var(--cargo-color)' : '' }} />
                                    </div>
                                </Tooltip>
                            </div>
                            <Flex>
                                <div>{secondTruckPrice}</div>
                                <div style={{ marginLeft: 2 }}>{currencySign(secondCurrency)}</div>
                            </Flex>
                        </Flex>
                    )}
                </Flex>
            )}
        </div>
    );
};

export default TariffCard;
